module.exports = __webpack_public_path__ + "img/pie.1b8183db.svg";